// @flow
import { coordsFromRadians } from '~/core/utils/math/trig';

export default (
    radians: number,
    context: CanvasRenderingContext2D,
    canvasWidth: number,
    canvasHeight: number,
    containerWidth: number,
    handleRadiusPercent: number,
    pickerDepthPercent: number
) => {
    const handleRadius = containerWidth / 100 * handleRadiusPercent;
    const pickerDepth = containerWidth / 100 * pickerDepthPercent;
    const vectorLength = canvasWidth / 2 - handleRadius - pickerDepth / 2;
    const { x, y } = coordsFromRadians(radians, vectorLength, canvasWidth, canvasHeight);

    const [r, g, b] = context.getImageData(x, y, 2, 2).data;
    return Uint8ClampedArray.from([r, g, b]);
};



// WEBPACK FOOTER //
// ./src/components/widgets/flipper/rgb-flipper/color-from-rad.js